module.exports = __webpack_public_path__ + "static/media/dex.6226ae0f.svg";